import { useState } from 'react'
import * as api from 'api/entityApi'

interface DocumentFormProps {
  entityId: string
  entityType?: 'lead' | 'enquiry'
  onSuccess?: (msg: string) => void
  onCancel?: () => void
}

export function DocumentForm({ entityId, entityType = 'lead', onSuccess }: DocumentFormProps) {
  const [documentTitle, setDocumentTitle] = useState<string>('')
  const [category, setCategory] = useState<string>('General')
  const [file, setFile] = useState<File | null>(null)

  const [submitting, setSubmitting] = useState<boolean>(false)
  const [error, setError] = useState<string>('')

  const handleReset = () => {
    setDocumentTitle('')
    setCategory('General')
    setFile(null)
    setError('')
  }

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault()
    if (!documentTitle.trim()) {
      setError('Document title is required.')
      return
    }
    setError('')
    setSubmitting(true)
    try {
      const msg = await api.submitDocument({
        entityId,
        entityType,
        documentTitle,
        category,
        file: file ?? undefined,
      })
      onSuccess?.(msg)
    } catch (err) {
      setError((err as Error).message || 'Failed to upload document.')
    } finally {
      setSubmitting(false)
    }
  }

  return (
    <div className="action-form">
      {error && <div className="alert alert-error">{error}</div>}

      <div className="form-group">
        <label className="form-label">
          Document Title <span className="req">*</span>
        </label>
        <input
          type="text"
          className="form-control"
          placeholder="e.g., GST Certificate / Agreement"
          value={documentTitle}
          onChange={(e) => setDocumentTitle(e.target.value)}
        />
      </div>

      <div className="form-group">
        <label className="form-label">Category</label>
        <select className="form-control" value={category} onChange={(e) => setCategory(e.target.value)}>
          <option value="General">General Document</option>
          <option value="ID Proof">Identity / Address Proof</option>
          <option value="Proposal">Proposal / Agreement</option>
          <option value="Invoice">Tax Invoice / Receipt</option>
        </select>
      </div>

      <div className="form-group">
        <label className="form-label">Select File</label>
        <input
          type="file"
          className="form-control"
          onChange={(e) => {
            if (e.target.files && e.target.files.length > 0) {
              setFile(e.target.files[0])
              if (!documentTitle) setDocumentTitle(e.target.files[0].name)
            }
          }}
        />
        {file && <div className="form-hint">Selected: {file.name} ({(file.size / 1024).toFixed(1)} KB)</div>}
      </div>

      <div className="action-form-footer">
        <button type="button" className="btn btn-default" onClick={handleReset} disabled={submitting}>
          Reset
        </button>
        <button type="button" className="btn pri-btn" disabled={submitting} onClick={handleSubmit}>
          {submitting ? 'Uploading…' : 'Upload Document'}
        </button>
      </div>
    </div>
  )
}
